import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { withTranslation } from 'react-i18next';
import ScrollArea from 'react-scrollbar';

import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import Button from 'reactstrap/lib/Button';
import Modal from 'reactstrap/lib/Modal';
import ModalHeader from 'reactstrap/lib/ModalHeader';
import ModalBody from 'reactstrap/lib/ModalBody';
import ModalFooter from 'reactstrap/lib/ModalFooter';
import Form from 'reactstrap/lib/Form';
import Input from 'reactstrap/lib/Input';
import Media from 'reactstrap/lib/Media';
import ScrollAreaButtons from './UI/ScrollAreaButtons';

import Message from './SupportMessage';

import closeImg from '../../images/icons/close.png';

import {
  sendSupportMessage,
  setSupportAsRead,
  setUserScreenViewNew,
  supportMessageFileUpload,
} from '../../actions/member';

import {
  checkAutoForCompensation,
  getChatTypingLive,
  setChatTyping,
  stopGetChatTypingLive,
} from '../../actions/admin';

import {
  DWEB_PLATFORM,
  FONT_MODE,
  SUPPORT_CHAT_MESSAGE_COUNT_LIMIT,
  ALLLOW_FILE,
  SCREENS,
} from '../../constants/constants';

import config from '../../constants/config';

const isInAppFrame = config.isInAppFrame();

class ContactSupport extends React.Component {
  static propTypes = {
  //  supportChatStatus: PropTypes.shape({
  //    read: PropTypes.bool,
  //  }),
    supportChat: PropTypes.shape(),
    uid: PropTypes.string,
    name: PropTypes.string,
    //  chatMessages: PropTypes.shape(),
    closeErrorSubmit: PropTypes.bool.isRequired,
    modalOpen: PropTypes.bool,
    resetClose: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
    sendSupportMsg: PropTypes.func.isRequired,
    supportMessageFileUpload: PropTypes.func.isRequired,
    //  setSupportRead: PropTypes.func.isRequired,
    toggle: PropTypes.func.isRequired,
    fontMode: PropTypes.string,
    checkAutoForComp: PropTypes.func.isRequired,
    platform: PropTypes.string,
    role: PropTypes.string,
    setScreenViewNew: PropTypes.func.isRequired,
  };

  static defaultProps = {
  //  chatMessages: {},
    uid: null,
    name: '',
    role: '',
    supportChat: null,
    //  supportChatStatus: null,
    modalOpen: false,
    fontMode: FONT_MODE.normal,
    platform: DWEB_PLATFORM,
  };

  constructor(props) {
    super(props);
    this.state = {
    //  modalOpen: false,
      inputMessage: '',
      fileUploadUrl: '',
      fileName: '',
      ableToSend: true,
      displayTyping: false,
    };
    this.hiddenFileInput = React.createRef(null);

    this.messagesScrollbar = React.createRef();

  }
  typingTimeout = null;
  typingCooldownSet = false;

  componentDidMount() {
    const { getChatTypingLiveFunc, uid } = this.props;
    getChatTypingLiveFunc(uid);
    this.scrollToBottom();
  }

  componentWillUnmount() {
    const { stopGetChatTypingLiveFunc, uid } = this.props;
    stopGetChatTypingLiveFunc(uid);
  }

  componentDidUpdate(prevProps) {
    const {
      closeErrorSubmit, resetClose, supportChat, modalOpen, setSupportRead, setScreenViewNew,
    } = this.props;
    const prevSupportChat = prevProps.supportChat;
    const prevModalOpen = prevProps.modalOpen;
    if (closeErrorSubmit) {
      resetClose();
      this.closeModal();
    }

    if (
      supportChat
      && (!prevSupportChat || (prevSupportChat && Object.keys(prevSupportChat).length !== Object.keys(supportChat).length)) ) {
      this.scrollToBottom();
      setSupportRead();
    }

    if (modalOpen && modalOpen !== prevModalOpen) {
      setScreenViewNew(SCREENS.TECHNICAL_SUPPORT);
      this.scrollToBottom();
    }

    if (prevProps.typingAdmin !== this.props.typingAdmin && !isNaN(this.props.typingAdmin)) {

      if (Date.now() - this.props.typingAdmin <= 1000) {

        this.setState({ displayTyping: true });

        if (this.typingTimeout) {
          clearTimeout(this.typingTimeout);
        }

        this.typingTimeout = setTimeout(() => {
          this.setState({ displayTyping: false });
        }, 5000);
      }
    }
  }

  scrollToBottom = () => {
    setTimeout(() => {
      if (this.messagesScrollbar.current) {
        //this.messagesScrollbar.scrollBottom();
        this.messagesScrollbar.current.scrollTop = this.messagesScrollbar.current.scrollHeight;
      }
    }, 200);
  };

  closeModal = () => {
  //  this.setState({ modalOpen: false });
  };

  /* toggle = () => {
    const { modalOpen } = this.state;
    const { setSupportRead, supportChatStatus } = this.props;

    if (!modalOpen && supportChatStatus && !supportChatStatus.read) {
      setSupportRead();
    }
  }; */

  handleChange = (event) => {
    const { setChatTypingFunc, uid } = this.props;
    if (event.key !== 'Enter' || (event.key === 'Enter' && event.shiftKey)) {
      const value = event.target.type === 'checkbox' ? event.target.checked : (event.target.value).slice(0, 300);

      this.setState({
        [event.target.name]: value,
      });

      if (!this.typingCooldownSet) {
        setChatTypingFunc(uid, 'user');
        this.typingCooldownSet = true;

        setTimeout(() => {
          this.typingCooldownSet = false;
        }, 5000);
      }
    }
  };

  handleEnter = (event) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      this.submitMessage();
    }
  };

  submitMessage = () => {
    const { sendSupportMsg, name, supportChat, uid, checkAutoForComp, platform, supportChatMessagesCount, t, showNotification } = this.props;
    const { inputMessage, fileUploadUrl, fileName } = this.state;
    console.log({ inputMessage }, { fileUploadUrl });

    if (supportChat && Object.keys(supportChat).length && Object.keys(supportChat).length >= 1000) {
      this.setState({ inputMessage: '' });
      return null;
    }

    let screen = 'dWeb';
    const userAgent = navigator.userAgent.toLowerCase();

    if (window.innerWidth <= 1280 && window.innerWidth > 832) {
      screen = 'tablet';
    } else if (window.innerWidth <= 832) {
      screen = 'mWeb';
    }

    console.log({screen}, {userAgent}, window.innerWidth, "device check old: --- 1")

    this.setState({ inputMessage: '', fileUploadUrl: '', fileName: '' });
    if (inputMessage != '' || fileUploadUrl != '') {
      let lastMessageKey;
      let lastMessage;

      console.log('Object.keys(supportChat)', Object.keys(supportChat), Object.keys(supportChat).length - 1);

      if (Object.keys(supportChat) && Object.keys(supportChat).length, Object.keys(supportChat)[Object.keys(supportChat).length - 1]) {
        lastMessageKey = Object.keys(supportChat)[Object.keys(supportChat).length - 1];
        if (lastMessageKey) {
          lastMessage = supportChat[lastMessageKey];
        }
      }

      console.log('lastMessageKey', lastMessage, lastMessageKey, supportChatMessagesCount);

      if (supportChatMessagesCount >= SUPPORT_CHAT_MESSAGE_COUNT_LIMIT && lastMessage && lastMessage.date > (Date.now() - (1000 * 60 * 5))) {
        const time = Math.round((Date.now() - lastMessage.date) / 1000);
        const timeLeft = (60 * 5) - time;

        const minutes = Math.floor(timeLeft / 60);
        const seconds = timeLeft % 60;

        console.log('show error for mesage limit', time, timeLeft, minutes, seconds);

        showNotification(t('support.warning'), t('support.messageLimit', { seconds, minutes }), 'warning');

        // return null;
      }

      return sendSupportMsg({
        message: inputMessage, name, fileUploadUrl, fileName, design: 'old', screen
      }).then((res) => {
        console.log('sendSupportMsg res', res);
        if (res.type === 'SUPPORT_MESSAGE_SUCCESS') {
          checkAutoForComp(uid, name);
        } else if (res.type === 'SUPPORT_MESSAGE_ERROR') {
          if (res.data === "Message limit reached") {

            // showNotification(t('support.warning'), t('support.messageLimit', { seconds: 10, minutes: 2 }), 'warning');
          } else {
            showNotification(t('support.warning'), res.data, 'warning');
          }
        }
      });
    }
  };

  _handleFileClick = () => {
    console.log("trigger", this.hiddenFileInput);
    this.hiddenFileInput.current.click();
  };

  chooseFile = (e) => {
    e.preventDefault();

    const { showNotification, t } = this.props;
    const target = e.target.files[0];
console.log(target?.type, "fileType")
    var typeList = ".jpg,.jpeg,.png,.pdf,.msword ,.doc,.rtf,.txt,ain";
    if (!typeList.includes((target?.type).substring((target?.type).length - 3)) || target.type == "") { return showNotification(t('support.error'), t('support.unsupportedFile'), 'danger'); }
    if (target.size / ALLLOW_FILE.unitSize > ALLLOW_FILE.allowSize) {
      showNotification(t('support.warning'), t('support.cantUpload'), 'warning');

      this.setState({
        fileUploadUrl: '',
        fileName: '',
      });
    } else {
      this.setState({ ableToSend: false });

      const { supportMessageFileUpload } = this.props;
      supportMessageFileUpload(target).then((data) => {
        this.setState({
          fileUploadUrl: data.url,
          fileName: target.name,
          ableToSend: true,
        });
        showNotification(t('support.success'), t('support.attachedSuccess'), 'success');
      });
    }
  }

  updateScrollPos = (val) => {
    this.setState({ scrollPos: val.topPosition || 0 });
  }

  scroll = (newVal) => {
    this.messagesScrollbar.scrollYTo(newVal);
  }

  handleKeyDown = (e) => {
    if ((e.ctrlKey || e.metaKey) && e.key === 'Enter' && !e.shiftKey && !e.altKey) {
      e.preventDefault();
      this.submitMessage();
    }
  };

  render() {
    const {
      inputMessage, scrollPos, ableToSend, fileName, displayTyping,
    } = this.state;

    const {
      t, modalOpen, toggle, supportChat, uid, fontMode, role,
    } = this.props;

    // toggle={toggle}
console.log("messagePos", scrollPos);
    return (
      <Row className="contact-support">
        <Modal container={'div > div'} isOpen={modalOpen} toggle={toggle} className={`contact-support-modal old-modal root-font-${fontMode} ${isInAppFrame ? 'modal-is-app-frame' : ''}`}>
          <ModalHeader
          //  toggle={toggle}
            toggle={toggle}
            className="contact-support-modal-header"
            close={(
              <Media
                src={closeImg}
                className="notification-header-close"
                alt="X"
              //  onClick={toggle}
                onClick={toggle}
              />
            )}
          >
            {t('support.contact')}

            <ul className="notification-header-description">
              <li>{t('support.description1')}</li>
              <li>{t('support.description2')}</li>
              <li>{t('support.description3')}</li>
            </ul>
          </ModalHeader>
          <ModalBody className="contact-support-modal-body">
            <>
              <Row>
                <div
                  className="col-md-12 contact-support-chat-body-wrapper"
                  style={{ height: 320, overflow: 'hidden auto' }}
                  md="12"
                  ref={this.messagesScrollbar}
                >
                  {/* <ScrollAreaButtons
                    scrollPos={scrollPos}
                    show={this.messagesScrollbar && this.messagesScrollbar.state && this.messagesScrollbar.state.realHeight > this.messagesScrollbar.state.containerHeight ? true : null}
                    scroll={this.scroll}
                    speed={30}
                    rightOffset={1}
                    topOffset={-1}
                    bottomOffset={-2}
                  />
                  <ScrollArea
                    speed={0.65}
                    className="overflow-hidden h-100"
                    contentClassName="contact-support-chat-body-scroll-area-content"
                  //  onScroll={this.handleScroll}
                  //  smoothScrolling
                    verticalContainerStyle={{
                      background: 'transparent',
                      opacity: 1,
                      width: 11,
                    }}
                    verticalScrollbarStyle={{
                      background: '#fff',
                      borderRadius: 1,
                      width: 10,
                    //  minScrollSize: 25,
                    }}
                    minScrollSize={30}
                    horizontal={false}
                    onScroll={this.updateScrollPos}
                    ref={(el) => { this.messagesScrollbar = el; }}
                  > */}
                    {supportChat
                      && Object.keys(supportChat).map(key => (
                        <Row key={key}>
                          <Col md="12">
                            <Message
                              uid={uid}
                              messageId={supportChat[key].messageId || null}
                              message={supportChat[key].message || null}
                              translationKey={supportChat[key].translationKey || null}
                              translationKeyData={supportChat[key].translationKeyData || {}}
                              filteredMessage={supportChat[key].filteredMessage || null}
                              fileUploadUrl={supportChat[key].fileUpload || null}
                              fileName={supportChat[key].fileName || null}
                              isFiltered={supportChat[key].isFiltered || false}
                              userUid={supportChat[key].userUid || null}
                              date={supportChat[key].date || null}
                              fontMode={fontMode}
                              t={t}
                            />
                          </Col>
                        </Row>
                      ))}
                  {/* </ScrollArea> */}
                </div>
                <Col md="12" className="text-left">
                  <div style={{opacity: displayTyping ? 1 : 0}} className="chat-body-typing" />
                </Col>
              </Row>
              <Row className="contact-support-chat-footer">
                <Form style={{ width: '100%' }} onSubmit={this.submitMessage}>
                  <Col md="12">
                    <Input
                      className="contact-support-chat-footer-input"
                      type="textarea"
                      name="inputMessage"
                      id="inputMessage"
                      autoComplete="off"
                      placeholder={`${t('common.writeMessage')}...`}
                      value={inputMessage}
                      onChange={this.handleChange}
                      onKeyDown={this.handleKeyDown}
                    />
                  </Col>
                </Form>
              </Row>
              <Row>
                <Button
                  className="btn-warning admin-file-upload-button"
                  onClick={this._handleFileClick}
                >
                  {fileName === '' ? t('support.chooseFile') : fileName}
                </Button>
                <input
                  id="filesDialog"
                  className="chat-footer-input admin-file-upload-input"
                  accept=".jpg,.png,.pdf,.doc,.rtf,.txt"
                  type="file"
                  ref={this.hiddenFileInput}
                  onChange={this.chooseFile}
                />
                {/*  <Input
                  ref={input => (this.inputRef = input)}
                  id="filesDialog"
                  className="chat-footer-input"
                  accept=".jpg,.png,.pdf,.doc,.rtf,.txt"
                  style={{ marginLeft: 20, display: 'none' }}
                  type="file"
                  onChange={(e) => { console.log('test2'); this.chooseFile(e.target.files[0]); }}
                /> */}
              </Row>
            </>
          </ModalBody>
          <ModalFooter className="contact-support-modal-footer">
            <Button
              type="button"
              className="contact-support-modal-footer-button"
              color="link"
              disabled={!ableToSend}
              onClick={this.submitMessage}
            >
              {t('common.send')}
            </Button>
            <Button
              type="button"
              className="contact-support-modal-footer-button"
              color="link"
              onClick={toggle}
            >
              {t('common.cancel')}
            </Button>
          </ModalFooter>
        </Modal>
      </Row>
    );
  }
}

const mapStateToProps = state => ({
  uid: state.member.uid || '',
  name: state.member.name || '',
  role: state.member.role || '',
  supportChat: state.member.supportChat || null,
  supportChatMessagesCount: state.member.supportChatMessagesCount || null,
  supportMessageError: state.member.supportChatMessagesCount || null,
  typingAdmin: state.admin.typingAdmin,
//  supportChatStatus: state.member.supportChatStatus || null,
});

const mapDispatchToProps = {
  getChatTypingLiveFunc: getChatTypingLive,
  stopGetChatTypingLiveFunc: stopGetChatTypingLive,
  setChatTypingFunc: setChatTyping,
  sendSupportMsg: sendSupportMessage,
  setSupportRead: setSupportAsRead,
  supportMessageFileUpload,
  checkAutoForComp: checkAutoForCompensation,
  setScreenViewNew: setUserScreenViewNew,
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('common')(ContactSupport));
